import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

export const Title = ({ length, text }) => {
  const { t } = useTranslation();

  return length ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <h1 className={styles.title}>{t(text)}</h1>
      <p className={styles.titleSearch_length}>
        {length} {t("search_result")}
      </p>
    </div>
  ) : (
    <h1 className={styles.title}>{t(text)}</h1>
  );
};
